import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ApmSelectJobsFlow } from './ApmSelectJobsFlow';

const ZONE_ID = 'apm-add-job';

/**
 * Single-select via apm-select-jobs MFE (Add Job hamburger flow, or change-job when eventId set).
 * Without eventId: pick job → activity type → start-jobs inside the MFE.
 */
const SingleSelectJobFlow = ({
  machineRef,
  machineId,
  erpResources,
  eventId,
  sourceEventRefs,
  onCancel,
  onComplete,
}) => {
  const context = useMemo(() => {
    return {
      machineRef,
      machineId,
      erpResources,
      selectionMode: 'single',
      ...(eventId != null ? { eventId: String(eventId) } : {}),
      ...(sourceEventRefs?.length ? { sourceEventRefs } : {}),
    };
  }, [machineRef, machineId, erpResources, eventId, sourceEventRefs]);

  return (
    <ApmSelectJobsFlow
      zoneId={ZONE_ID}
      context={context}
      onCancel={onCancel}
      onComplete={onComplete}
    />
  );
};

SingleSelectJobFlow.propTypes = {
  machineRef: PropTypes.number,
  machineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  erpResources: PropTypes.arrayOf(PropTypes.string),
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sourceEventRefs: PropTypes.arrayOf(PropTypes.number),
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
};

SingleSelectJobFlow.defaultProps = {
  machineRef: undefined,
  machineId: undefined,
  erpResources: undefined,
  eventId: undefined,
  sourceEventRefs: undefined,
  onComplete: undefined,
};

export { SingleSelectJobFlow };
